export enum SHIFT_QUICK_SELECT_SLOTS {
  CurrentShift = 'currentShift',
  PastShift = 'pastShift',
  Today = 'today',
  Last24hours = 'last24hours',
  Yesterday = 'yesterday',
  LastWeekend = 'lastWeekend',
  Last3days = 'last3days',
  Last7days = 'last7days',
  Last30days = 'last30days',
  Next30days = 'next30days',
  Rolling12months = 'rolling12months'
}

export type ShiftQuickSelectSlots = SHIFT_QUICK_SELECT_SLOTS[number]

export enum EXTENDED_SHIFT_QUICK_SELECT_SLOTS_EXTRA {
  LastMonth = 'lastMonth',
  CurrentMonth = 'currentMonth',
  ShiftBeforePastShift = 'shiftBeforePastShift',
  TheDayBeforeYesterday = 'theDayBeforeYesterday',
  TheWeekendBeforeLast = 'theWeekendBeforeLast',
  MonthBeforeLastMonth = 'monthBeforeLastMonth'
}

export type ExtendedShiftQuickSelectSlots =
  | SHIFT_QUICK_SELECT_SLOTS
  | EXTENDED_SHIFT_QUICK_SELECT_SLOTS_EXTRA[number]

export const SHIFT_QUICK_SELECT_SLOT_LIST = Object.values(SHIFT_QUICK_SELECT_SLOTS)
